import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {TarjetaResumenCantidadComponent} from "./tarjeta-resumen-cantidad.component";

@NgModule({
  declarations: [
    TarjetaResumenCantidadComponent
  ],
  exports: [
    TarjetaResumenCantidadComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ]
})
export class TarjetaResumenCantidadModule {
}
